// removed by extract-text-webpack-plugin
module.exports = {"carouselWrapper":"image-carousel-module__carouselWrapper___3dJ7A","singleImage":"image-carousel-module__singleImage___1_WhU","nextButton":"image-carousel-module__nextButton___2As6t","prevButton":"image-carousel-module__prevButton___c6Ov1","carouselButton":"image-carousel-module__carouselButton___2rS9k","disabled":"image-carousel-module__disabled___qmXVN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/image-carousel/image-carousel.module.scss
// module id = 788
// module chunks = 0